import './App.css';
import './index.css';
import { useState } from 'react';
import items from './productsContent.js';
import Menu from './Components/Menu';
import Button from './Components/Button';
import Logo from './pics/Logo/Square-White-Logo-with-Cloured-Background.svg';


const allCategories = ['All', ...new Set(items.map(item => item.category))];

console.log(allCategories);

function App() {
  const [menuItem, setMenuItem] = useState(items);
  const [buttons, setButtons] = useState(allCategories);

  //Filter Function
  const filter = (button) =>{

    if(button === 'All'){
      setMenuItem(items);
      return;
    }

    const filteredData = items.filter(item => item.category ===  button);
    setMenuItem(filteredData)
  }


  return (
    <body id="productBody">
      <div className="container">
        <div id='headerContainer'>
          <h1 className = "header">Our Products</h1> 
          <img src={Logo} alt="logo" height={100} className="headerLogo"/>
        </div>
        <Button button={buttons} filter={filter} />
       <Menu menuItem={menuItem}/>

      </div>
    </body>
  );
}

export default App;
